import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// City - Get All (Read)
export const GetAllCity = createAsyncThunk(
  "masters/city/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Masters.City}?term=${filter?.name || ""}&searchState=${filter?.state_id || ""
        }&searchCountry=${filter?.country_id || ""}&page=${filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// City - Get (Read)
export const GetCity = createAsyncThunk(
  "masters/city/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Masters.City}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// City - Create (Add)
export const AddCity = createAsyncThunk(
  "masters/city/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Masters.City, data);
      if (res.success) {
        return res; // The new country object
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// City - Update
export const UpdateCity = createAsyncThunk(
  "masters/city/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Masters.City}/${id}`, data);
      if (res.success) {
        return res; // The new country object
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// City - Delete
export const DeleteCity = createAsyncThunk(
  "masters/city/delete",
  async (id, { rejectWithValue }) => {
    try {
      await DELETE(`${APIS.Masters.City}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// City - Status
export const StatusCity = createAsyncThunk(
  "masters/city/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Masters.City}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "city",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllCity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllCity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllCity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetCity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetCity.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetCity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AddCity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AddCity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(AddCity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(UpdateCity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UpdateCity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const index = state.data.findIndex(
          (city) => city.id === action.payload?.data?.id
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(UpdateCity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(DeleteCity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(DeleteCity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = state.data.filter((city) => city.id !== action.payload);
      })
      .addCase(DeleteCity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(StatusCity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusCity.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(StatusCity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export default Slice.reducer;
